module.exports = __webpack_public_path__ + "static/img/msg_tab2.d7110bed.png";